import React from 'react';  
import { connect } from 'react-redux'
import { Container } from 'react-bootstrap'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import CardColumns from 'react-bootstrap/CardColumns'
import Card from 'react-bootstrap/Card'
import Image from 'react-bootstrap/Image'

import { ACT_EDITLOG, ACT_COPYLOG, ACT_NEWLOG, ACT_GOTLOGS, ACT_LOGOUT } from './actions.js';

import TooltipButton from './TooltipButton.jsx'
import LoggingCard from './LoggingCard.jsx';
import moment from 'moment';  

import './css/PeriodLogging.css';
import { WL, WL_SUCCESS, WL_FAIL, WL_EXCEPTION, WL_UNAUTHORIZED } from './WebLoggerService.jsx'

import $ from 'jquery'



class PeriodLogging extends React.Component {  

	constructor(props) {
		super(props)
		this.DeleteLogResult = this.DeleteLogResult.bind(this)
		this.GetLogsResult = this.GetLogsResult.bind(this)
		this.state={ projects: { }}
	}

	render() {  
	
		var lstLoggings = this.props.lstLoggings.filter((log)=>{
			
			if (this.props.endDate===null){
				let result = moment(log.startDate).isSame(this.props.startDate,'day')
				return result;
			}
			else{
				let result = moment(log.startDate).isBetween(this.props.startDate,this.props.endDate,'day','[]')
				return result;
			}
		});
		
		
		var columnCount = parseInt($("#cards").css("columnCount"))
		//console.log("Getting name")
		var columnCountMax = parseInt($("#cards").attr("name"))
		//console.log("Got name")
		//console.log("max columns(name)=" + columnCountMax)
		//console.log("max columns=" + columnCount)

		
		if (isNaN(columnCountMax) )
			columnCountMax = columnCount

		//console.log("num of card to show = " + (lstLoggings.length +1))
		if (lstLoggings.length + 1 < columnCountMax)
			columnCount = lstLoggings.length + 1
		else
			columnCount = columnCountMax

		columnCount = columnCount.toString()
		//console.log("num of columns to show = " + columnCount)

		if (isNaN(columnCountMax)) columnCountMax=''

		
		return (  
			<Container fluid={true} style={{ padding: "0px", margin: "0px", width: "100%"}}>
				<Row className="justify-content-center">
					<Col style={{ width: "100%" }}>
						<CardColumns id="cards" name={columnCountMax} style={{ padding: "0px", width: "100%", columnCount}} >
							{
								
								lstLoggings.map((logging, idx) => 
									
									<LoggingCard key={idx} idx={idx}
										data={logging}
										showLogsInHours={this.props.projects && this.props.projects[logging.projectId] && this.props.projects[logging.projectId].showLogsInHours}
										deleteLog={() => this.deleteLog(logging.logId)}
										editLog={() => this.props.editLog(logging.logId)}
										copyLog={() => this.props.copyLog(logging.logId)}
										showDate={this.props.endDate !== null && !this.props.endDate.isSame(this.props.startDate)}
									/>
								)
								
							}
							<Card style={{ padding: "5px", width: "100%", backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
								<Row>
									<TooltipButton className="mx-auto" tooltiptext="Add New Log(s)" variant="outline-light" onClick={() => { this.props.newLog() }} content={<Image alt="Nieuwe Log" src={(this.props.endDate !== null && this.props.startDate !== null && !this.props.endDate.isSame(this.props.startDate)) ? "plusplus.png" : "plus.png"} style={{ width: "32px" }} />} />
								</Row>
							</Card>
						</CardColumns>
					</Col>
				</Row>
					
			</Container>
		    
      );  
	}  

	deleteLog(logId) {
		WL.DeleteLog(this.props.token, {logId}, this.DeleteLogResult)
	}

	DeleteLogResult(result, data) {
		if (result === WL_UNAUTHORIZED) {
			console.log("Not authenticated to delete the logging")
			this.props.logout()
		} else if (result === WL_EXCEPTION) {
			console.log("Exception while getting logs")
		} else if (result === WL_FAIL) {
			console.log("Failed to get logs")
		} else if (result === WL_SUCCESS) {
			console.log("Log deleted. Refreshing logging")
			WL.GetLogs(this.props.token, this.GetLogsResult)
		}
	}


	GetLogsResult(result, data) {
		if (result === WL_UNAUTHORIZED) {
			console.log("Not authenticated to get the logging")
			this.props.logout()
		} else if (result === WL_EXCEPTION) {
			console.log("Exception while getting logs")
		} else if (result === WL_FAIL) {
			console.log("Failed to get logs")
		} else if (result === WL_SUCCESS) {
			//console.log("Received logs. Applying them")
			this.props.gotLogs(data)

		}
	}
}  

function mapDispatchToProps(dispatch) {
    return {
		editLog: (logId) => { dispatch({ type: ACT_EDITLOG, logId }) },
		copyLog: (logId) => { dispatch({ type: ACT_COPYLOG, logId }) },
		newLog: () => { dispatch({ type: ACT_NEWLOG }) },
		logout: () => { dispatch({ type: ACT_LOGOUT }) },
		gotLogs: (data) => { dispatch({ type: ACT_GOTLOGS, logs: data }) }
    }

}

function mapStateToProps(state) {
    var startDate = state.period.startDate===null?null:moment(state.period.startDate).startOf("day")
	var endDate = state.period.endDate === null ? null : moment(state.period.endDate).startOf("day")
	var mapPrjs = {}
	//console.log("#project=" + state.projects.allProjects.length)
	state.projects.allProjects.forEach(prj => { mapPrjs[prj.id] = prj })
	//for (var k in mapPrjs) { console.log(mapPrjs[k]) }
	//console.log("#project=" + Object.keys(mapPrjs).length)
		
	return { projects: mapPrjs, lstLoggings: state.logging.lstLoggings, startDate, endDate, token: state.user.userInfo["token"]}
}
  
export default connect(mapStateToProps,mapDispatchToProps)(PeriodLogging);  